import React from 'react'
import * as  C from "../componentsM/index"

const HOLISTIC = () => {
    return (
        <>

            <C.Hero title={"HOLISTIC INTERDISCIPLINARY PROGRAMME"}
                image={"/hero/11.jpg"} />


            <section className='p-4 md:p-24'>

                <div className='flex flex-col gap-5'>


                    <p>The MYP is an interdisciplinary programme that transcends barriers of disciplines to provide for a holistic learning experience. This trait emerges as a consequence of the challenges and opportunities of educating students in, and for, a complex and highly interconnected world. Younger learners often make connections naturally between knowledge domains in order to understand the world around them—in some cases, because they have not yet been socialised into the disciplinary perspectives that organise the academic world. Even though secondary education usefully organises learning into disciplinary compartments (as a response to increasing specialisation), an ever-changing world also demands education that empowers people to integrate disciplines in novel and creative ways. As knowledge and information multiply, critical thinkers must successfully integrate disciplinary perspectives to understand complex issues and ideas.</p>


                    <p>Meaningful interdisciplinary teaching and learning experiences:</p>


                    <ul className="list-disc list-inside my-2">
                        {[
                            "Allow students to use knowledge domains creatively to foster new understanding",
                            "Develop mental flexibility that prepares students to be lifelong learners",
                            "Promote intellectual rigour by providing a holistic approach to the study of complex issues and ideas",
                            "Model the importance of collaboration and teamwork across disciplines (an important life skill)",
                            "Support and promote transfer of understanding."
                        ]
                            .map((item, index) => (
                                <li key={index} className="text-sm">{item}</li>
                            ))}
                    </ul>


                </div>
            </section>

        </>

    )
}

export default HOLISTIC